import { useEffect } from 'react';
import Lenis from 'lenis';

/**
 * Smooth global scroll. Mounts once at the app root.
 * - Touch-enabled with sensible defaults so mobile feels smooth like desktop.
 * - Respects prefers-reduced-motion.
 */
const SmoothScroll = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      // @ts-expect-error - lenis option still supported
      smoothTouch: true,
      touchMultiplier: 1.4,
      wheelMultiplier: 1,
    });

    let rafId = 0;
    const raf = (time: number) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return null;
};

export default SmoothScroll;
